// Pause playing videos on modal close
jQuery('.modal').on('hidden.bs.modal', function () {
  let video = jQuery(this).find('video');
  if(video) {
    video.trigger('pause');
  }
});
